import { render, staticRenderFns } from "./StudentUploadDocuments.vue?vue&type=template&id=967e42b4&"
import script from "./StudentUploadDocuments.vue?vue&type=script&lang=ts&"
export * from "./StudentUploadDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports